import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: "850px",
        maxWidth: "850px"
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 0px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        cursor: 'move',
        backgroundColor: "#0049A3",
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '10px 20px',
        background: '#f5f5f5',
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    errorBtn: {
        fontSize: '13px',
        lineHeight: '16px',
        fontWeight: 600,
        color: 'white',
        marginRight: '5px',
        borderRadius: '4px',
        padding: '7px 16px',
        textTransform: 'capitalize',
        border: '0px solid #0049A3',
        background: '#e20000',
        '&:hover': {
            color: '#ffffff',
            background: '#f20000',
        }
    },

    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    '@keyframes letterSpacingGrow': {
        '0%': {
            letterSpacing: '0em',
            opacity: 0,
        },
        '100%': {
            letterSpacing: '0.2em',
            opacity: 1,
        },
    },

    processCount: {
        border: '1px solid #d6d6d6',
        padding: '5px 15px',
        marginTop: '4px',
        borderRadius: '6px',
        minHeight: '122px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1b385c',
        flexFlow: 'column',
        "& h3": {
            padding: 0,
            color: 'white',
            margin: 0,
            fontWeight: 'bold',
            fontSize: '17px',
            letterSpacing: 'initial',
            textTransform: 'uppercase',
            animation: 'letterSpacingGrow 0.6s ease-out forwards',
        }
    },
    circularProgressBar: {
        marginLeft: 0,
        marginRight: '8px',
        color: "#FFFFFF"
    },
}));